var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-btn"},[_c('a',{staticClass:"link-btn__anchor",attrs:{"href":_vm.href,"target":_vm.blank ? '_blank' : '',"rel":_vm.rel}},[_c('i',{class:_vm.icon}),_c('span',{staticClass:"link-btn__text"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }